<template>
    <div
    v-touch:swipe.left="hasExternalSwipe ? null : swipeLeft"
    v-touch:swipe.right="hasExternalSwipe ? null : swipeRight"
    class="slider-content-wrapper">
        <div ref="sliderRef" class="slider-wrapper" :style="{ height: (!hideCircles && sliderList.length > 1) ? `${itemHeight + 28 + 16}px` : null }" :class="{'no-padding-top': hasExternalSwipe}">
            <slot></slot>
        </div>
        <!-- Circles to visually see our position in slider -->
        <navigation-circles-wrapper
        v-if="!hideCircles && sliderList.length > 1"
        :listLength="sliderList.length"
        :selectedIndex="internalSelectedIndex"/>
    </div>
</template>

<script setup>
import NavigationCirclesWrapper from '@/components/generic/sliders/navigation/CirclesWrapper.vue'
/* Vue & Aux */
import { ref, watch, onMounted } from 'vue'
import { scrollTo } from '@/assets/scripts/scrollAnimation'

const emit = defineEmits(['updateSelectedIndex'])

/* Props
@selectedIndex { Number }
@sliderList { Array } - in which object with card info, needs to have:
	- title { String }
	- shortDescription { String }
@hasExternalSwipe {Boolean} to prevent swiptFunction from being trigger, when parent component has full swipe on it, preving index from changing twice
@hideCircles {Boolean} hide circles bellow cards
*/
const props = defineProps({
    selectedIndex: Number,
    sliderList: Array,
    hasExternalSwipe: Boolean,
    hideCircles: Boolean
})

const sliderRef = ref('')
const internalSelectedIndex = ref(props.selectedIndex || 0)
const itemHeight = ref(null)

watch(() => props.selectedIndex, (newVal, oldVal) => {
    if (newVal === oldVal) return

    internalSelectedIndex.value = newVal
    if (newVal > oldVal) moveLeft()
    else if (newVal < oldVal) moveRight()
})

/*************************************************
 *                                                *
 *                Swipe/Move Handlers             *
 *                                                *
 *************************************************/
const swipeLeft = () => {
    if (internalSelectedIndex.value === (props.sliderList.length - 1)) return
    internalSelectedIndex.value++
    moveLeft()
}

const swipeRight = () => {
    if (internalSelectedIndex.value === 0) return
    internalSelectedIndex.value--
    moveRight()
}

const moveLeft = () => {
    const newScrollPosition = ((sliderRef.value.children[0].clientWidth + 8 /* gap */) * internalSelectedIndex.value)
    emit('updateSelectedIndex', internalSelectedIndex.value)
    scrollTo(sliderRef.value, newScrollPosition, null, 1000, 'horizontal')
}

const moveRight = () => {
    const newScrollPosition = ((sliderRef.value.children[0].clientWidth + 8 /* gap */) * internalSelectedIndex.value)
    emit('updateSelectedIndex', internalSelectedIndex.value)
    scrollTo(sliderRef.value, newScrollPosition, null, 1000, 'horizontal')
}

onMounted(() => {
    itemHeight.value = sliderRef.value.children[0].clientHeight
})
</script>

<style lang="scss" scoped>
.slider-content-wrapper {
    width: 100%;
    height: auto;

    display: flex;
    flex-direction: column;

    overflow: hidden;
    position: relative;

    .slider-wrapper {
        width: 100%;
        height: fit-content;
        padding: 16px 32px 0 32px;

        display: flex;
        gap: 8px;
        overflow: hidden;

        &.no-padding-top {
            padding-top: 0;
        }
    }
}
</style>
